import React, {useState, useRef, useEffect} from 'react';
import {fetchJson} from '../../utils/util_functions';
import Menu from '../nav/Menu';
import Link from '../nav/Link';
import Dropdown from '../nav/Dropdown';
import { useFlags } from 'launchdarkly-react-client-sdk';
import './style.scss';

export default function NavHeaderBottom(props) {

  const [menuData, setMenuData] = useState([]);
  const flags = useFlags();

  useEffect(() => {
    let path = process.env.CMS_API + 'header-navigation' + (process.env.NODE_ENV == "local" ? ".json" : "?_format=json");
    fetchJson(path).then((json) => {
      setMenuData(json);
    });
  }, []);

  return (
    <div className={`aps__nav-header__bottom`}>
      <div className={`constrain`}>
        <Menu>
          {menuData.map((item) => {
            if (!item.enabled) {
              return;
            }
            if (item.options?.attributes?.flag) {
              if (flags[item.options.attributes.flag] === false) {
                return;
              }
            }
            if (item.below?.length) {
              return (
                <Dropdown key={item.key}
                          classes={item.options?.attributes?.class ? item.options.attributes.class.join(' ') : ''}
                          links={item.below}
                          title={item.title}>
                </Dropdown>
              );
            } else {
              return (
                <Link key={item.key}
                      link={item.absolute}
                      target={item.options?.attributes?.target ? item.options.attributes.target : ''}
                      classes={item.options?.attributes?.class ? item.options.attributes.class.join(' ') : ''}>
                  {item.title}
                </Link>
              );
            }
          })}
        </Menu>
      </div>
    </div>
  );
}
